<template>
    <div id="purchase-costs">
        <step-title class="purchase-costs-header" step-title="Purchase Costs"></step-title>
        <div class="calc-col-one">
            <text-field-with-symbol class="calc-input purchase-price" :value="purchasePriceValue" v-on:calc="calcPurchasePriceValue" name="Purchase-Price" label="Purchase Price" is-bold-font placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
            <div style="width: 85%; margin-left: auto; margin-right: auto">
                <span v-show="!this.$store.state.purchasePriceEntered" class="purchase-price-require-info text-danger" style="float: right; height: 0; font-size: 13px; margin-top: -18px;">Input Required</span>
            </div>
            <button-group-two class="calc-input deposit-source" :current-value="depositSourceValue" v-on:calcOne="calcDepositSourceValue" v-on:calcTwo="calcDepositSourceValue" name="Deposit" label="Deposit" button-one-text="Cash" button-two-text="Equity" has-tooltip></button-group-two>
            <two-text-fields-with-symbols class="calc-input" :value-one="depositPercentageValue" :value-two="depositAmountValue" v-on:calcOne="calcDepositPercentageValue" v-on:calcTwo="calcDepositAmountValue" placeholder-one="" placeholder-two="" symbol-one="%" symbol-two="$" v-bind:has-tooltip="false"></two-text-fields-with-symbols>
            <text-field class="calc-input bottom-margin-0" :value="propertySuburbValue" v-on:calc="calcPropertySuburbValue" name="Property-Suburb" label="Property Suburb" v-bind:is-bold-font="false" placeholder="" has-tooltip></text-field>
            <div style="width: 85%; margin-left: auto; margin-right: auto">
                <span v-show="!this.$store.state.propertySuburbEntered" class="property-suburb-require-info text-danger" style="float: right; height: 0; font-size: 13px; margin-top: -18px;">Input Required</span>
            </div>
            <text-field-with-symbol class="calc-input stamp-duty" :value="stampDutyValue" v-on:calc="calcStampDutyValue" disabled name="Stamp-Duty" label="Stamp Duty" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
        </div>
        <div class="calc-col-two">
            <text-field-with-symbol class="calc-input legal-fees" :value="legalFeesValue" v-on:calc="calcLegalFeesValue" name="Legal-Fees" label="Legal Fees" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
            <text-field-with-symbol class="calc-input pre-purchase-costs extra-bottom-margin-width-max-328" :value="prepurchaseInspectionsValue" v-on:calc="calcPrepurchaseInspectionsValue" name="Pre-purchase-Costs" label="Pre-purchase Costs" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
            <text-field-with-symbol class="calc-input other-costs" :value="otherFeesCostsValue" v-on:calc="calcOtherFeesCostsValue" name="Other-Fees-And-Costs" label="Other Fees & Costs" v-bind:is-bold-font="false" placeholder="" symbol="$" has-tooltip></text-field-with-symbol>
        </div>
        <step-result-label result-label="TOTAL PURCHASE COSTS" :step-result="totalValue"></step-result-label>
    </div>
</template>

<script>
    import StepTitle from './StepTitle';
    import TextFieldWithSymbol from './TextFieldWithSymbol';
    import ButtonGroupTwo from './ButtonGroupTwo';
    import TwoTextFieldsWithSymbols from './TwoTextFieldsWithSymbols';
    import TextField from './TextField';
    import StepResultLabel from './StepResultLabel';

    import axios from 'axios';

    export default {
        components: {
            StepTitle,
            TextFieldWithSymbol,
            ButtonGroupTwo,
            TwoTextFieldsWithSymbols,
            TextField,
            StepResultLabel
        },
        name: "purchase-costs",
        computed: {
            propertySuburbValue() {
                return this.$store.state.purchaseCosts.getPropertySuburb();
            },
            purchasePriceValue() {
                return this.$store.state.purchaseCosts.getPurchasePrice();
            },
            depositSourceValue() {
                return this.$store.state.purchaseCosts.getDepositSource();
            },
            depositAmountValue() {
                return this.$store.state.purchaseCosts.getDepositAmount();
            },
            depositPercentageValue() {
                return this.$store.state.purchaseCosts.getDepositPercentage();
            },
            stampDutyValue() {
                return this.$store.state.purchaseCosts.getStampDuty();
            },
            legalFeesValue() {
                return this.$store.state.purchaseCosts.getLegalFees();
            },
            prepurchaseInspectionsValue() {
                return this.$store.state.purchaseCosts.getPrepurchaseInspections();
            },
            otherFeesCostsValue() {
                return this.$store.state.purchaseCosts.getOtherFeesCosts();
            },
            totalValue() {
                return this.$store.state.purchaseCosts.getTotal();
            }
        },
        methods: {
            calcPropertySuburbValue: function(propertySuburb) {
                this.$store.commit('propertySuburbValueCalc', propertySuburb);
            },
            calcPurchasePriceValue: function(purchasePrice) {
                this.$store.commit('purchasePriceValueCalc', purchasePrice);

                var propertyPrice = this.$store.state.purchaseCosts.getPurchasePrice();
                var city = this.$store.state.taxFactors.getNearestCapitalCity();
                city = city.toUpperCase();

                var buildingCategory = this.$store.state.taxFactors.getPropertyType();
                if (buildingCategory === 'House/Townhouse') {
                    buildingCategory = 'House'
                } else if (buildingCategory === 'Commercial Property') {
                    buildingCategory = 'Commercial Suite'
                } else if (buildingCategory === 'Industrial Property') {
                    buildingCategory = 'Industrial Suite'
                }

                var buildingQuality = this.$store.state.taxFactors.getStandardOfFinish();
                buildingQuality = buildingQuality.toUpperCase();
                var buildYear = this.$store.state.taxFactors.getConstructionYear();
                var purchaseDate = this.$store.state.taxFactors.getPurchaseDate();
                var propertyBought = this.$store.state.taxFactors.getPropertyBought();

                var budgetChange;
                if (purchaseDate === "Yes") {
                    budgetChange = 0;
                } else if (purchaseDate === "No" && propertyBought === '2nd Hand') {
                    budgetChange = 1;
                } else if (purchaseDate === "No" && propertyBought === 'Brand New') {
                    budgetChange = 2;
                }

                axios.get('https://cors.bridged.cc/https://portal.washingtonbrown.com.au/webservices/default.aspx?unm=kHhQt/' +
                    'dk4l+87aYxO0YoqWVdaLfDiapGmj+Q0L9Dmq8HIKOikWsUf4yN8tjwOr1Rz4E/' +
                    'wwvxsuXczoal7deYib3Ig3UMYP+3&ResultType=0', {
                    headers: {
                        'Origin': '*',
                        'Access-Control-Allow-Origin': '*'
                    },
                    params: {
                        PropertyPrice: propertyPrice,
                        City: city,
                        BuildingCategory: buildingCategory,
                        BuildingQuality: buildingQuality,
                        BuildYear: buildYear,
                        BudgetChange: budgetChange
                    }
                }).then(response => {
                    var data = response.data;

                    var estimatedAmountStartIndex = data.indexOf('<DV_YEAR_1>') + 11;
                    var estimatedAmountEndIndex = data.indexOf('</DV_YEAR_1>');

                    var estimatedAmount = Number(data.substring(estimatedAmountStartIndex, estimatedAmountEndIndex));
                    var successfullyCalculated = true;

                    if (isNaN(estimatedAmount)) {
                        estimatedAmount = 0;
                        successfullyCalculated = false;
                    }

                    this.$store.commit('estimatedAmountValueCalc', estimatedAmount);
                    this.$store.commit('successfullyCalculatedDepreciationAmount', successfullyCalculated);
                }).catch(e => {

                    });
            },
            calcDepositSourceValue: function(depositSource) {
                this.$store.commit('depositSourceValueCalc', depositSource);
            },
            calcDepositAmountValue: function(depositAmount) {
                this.$store.commit('depositAmountValueCalc', depositAmount);
            },
            calcDepositPercentageValue: function(depositPercentage) {
                this.$store.commit('depositPercentageValueCalc', depositPercentage);
            },
            calcStampDutyValue: function(stampDuty) {
                this.$store.commit('stampDutyValueCalc', stampDuty);
            },
            calcLegalFeesValue: function(legalFees) {
                this.$store.commit('legalFeesValueCalc', legalFees);
            },
            calcPrepurchaseInspectionsValue: function(prepurchaseInspections) {
                this.$store.commit('prepurchaseInspectionsValueCalc', prepurchaseInspections);
            },
            calcOtherFeesCostsValue: function(otherFeesCosts) {
                this.$store.commit('otherFeesCostsValueCalc', otherFeesCosts);
            },
            calcTotalValue: function() {
                this.$store.commit('totalValueCalc');
            }
        }
    }
</script>

<style scoped>

    #purchase-costs {
        overflow: visible;
    }

    .purchase-costs-header {
        margin-bottom: 30px;
    }

    .purchase-price {
        display: block !important;
    }

    .deposit-source {
        overflow: visible !important;
    }

    @media not print {
        @media (min-width: 1024px) {

            .calc-col-one {
                width: 50%;
                float: left;
            }

            .calc-col-two {
                width: 50%;
                float: right;
            }

            .purchase-price {
                display: flex !important;
            }

            .purchase-price-require-info {
                margin-top: -30px !important;
            }

            .property-suburb-require-info {
                margin-top: -32px !important;
            }
        }
    }

    @media (max-width: 1023px) {
        .bottom-margin-0 {
            margin-bottom: 0 !important;
        }
    }

    @media (max-width: 328px) {

        .legal-fees {
            margin-bottom: 30px !important;
        }

        .extra-bottom-margin-width-max-328 {
            margin-bottom: 60px !important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/Components/PurchaseCosts.vue